import React from 'react';
import { Box } from '@mui/material';

const Screen = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      {children}
    </Box>
  );
};

export default Screen;